import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { useCallback, useMemo } from "react"

import { Wrapper } from "../styled"
import type { ComponentProps } from "."

const DateComponent = ({
  disabled,
  label,
  onChange,
  value
}: ComponentProps) => {
  const slotProps = useMemo(
    () => ({
      openPickerButton: { "aria-label": "change release date" },
      popper: { sx: { zIndex: 10000 } }
    }),
    []
  )

  // Always coerce to UTC midnight ISO when user picks a date
  const handleChange = useCallback(
    (date: Date | null) => {
      if (!date) return

      const isoMidnight = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
      ).toISOString()

      onChange(isoMidnight)
    },
    [onChange]
  )

  // Ensure picker gets a Date (it can receive string upstream)
  const pickerValue = typeof value === "string" ? new Date(value) : value

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Wrapper>
        <DatePicker
          closeOnSelect
          disabled={disabled}
          format="dd/MM/yyyy"
          label={label}
          onChange={handleChange}
          slotProps={slotProps}
          value={pickerValue ?? null}
        />
      </Wrapper>
    </LocalizationProvider>
  )
}

export default DateComponent
